module.exports = __webpack_public_path__ + "static/media/logo.19714e0e.jpg";